@if (condition) {
  <div class="current-station-type-editor" [formGroup]="detailsFormGroup">
    <div class="row">
      <mat-form-field class="flex-grow" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.current-station-type-editor.current-station-type"></sc-dictionary-label>
        </mat-label>
        <mat-select formControlName="stationType" name="stationType">
          @for (type of stationTypes; track type) {
            <mat-option [value]="type">
              <sc-dictionary-label dictionaryKey="tmc-yard.common.enum.station-type.{{type}}"></sc-dictionary-label>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
}
